// @flow
import { PRODUCTS_FILTERS } from 'Client/cms/toolkit/constants';
import * as configQueries from 'Views/configQueries';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { LINE_OFFER_PRODUCT_FILTER } from 'Utils/request/requestDictionary';
import { addTranslationKeys } from 'Src/i18n';

type CMSProps = {
  offerId?: string,
};

type GQLProps = {
  config: CMSContent,
  offer: Offer,
};

export const productsFiltersResolver = {
  name: PRODUCTS_FILTERS,
  resolve(appContext: AppContext, props: CMSProps = {}): Promise<GQLProps> {
    const { offerId = '' } = props;
    const query = `{
      config {
        ${configQueries.resort(appContext)}
        ${configQueries.price()}
        ${configQueries.faceting()}
        common { close thumbnailCTA next previous scrollBackward scrollForward }
        remote {
          date
          searchAction
          noResult {
            zeroResult
            explanation
          }
        }
      }
      offer(offerId: "${offerId}") {
        id
        name
        seoName
        color
        products {
          id
          price {
            bestPrice {
              value
              formattedValue
            }
            initialPrice {
              value
              formattedValue
            }
            unit
            currency
            termsAndConditions {
              departureDate
              duration
              durationFormatted
              numberOfAdults
              accommodationComfortLabel
            }
          }
        }
      }
    }`;

    return graphQLClient
      .runQuery(query, appContext, {
        requestName: LINE_OFFER_PRODUCT_FILTER,
        strictErrors: false,
      })
      .then(data => {
        addTranslationKeys(data.config);
        return data;
      });
  },
};
